module.exports = __webpack_public_path__ + "static/img/181221-feature-talent.774738d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181221-feature-talent.jpg
// module id = JQT+
// module chunks = 0